<template>
  <v-container
    fluid
    class="main--text">
    <v-row
      justify=center>
      <v-col
        cols=auto>
        <v-card
          width=600>
          <v-container
            v-if="records"
            fluid
            >
            <v-row
              no-gutters
              align=center>
              <v-col><h3>終了した授業一覧</h3>
              </v-col>
            </v-row>
            <template
              v-for="(record, index) in records.get()"
              >
              <v-lesson-record
                :key="record.id"
                :record="record"
                @update-button-click="updateRecord(record, $event)"
                @remove-button-click="removeRecord"
                />
                <v-divider v-if="records.length() > index+1" :key="index"></v-divider>
            </template>
            <v-divider></v-divider>
            <v-row
              no-gutters
              justify=end
              align=end>
              <v-col
                cols=auto>
              <span>合計授業料：　</span>
                <span class="font-weight-bold headline main--text">{{ records.getPaymentAmount() }}</span>
                <span class="subheading main--text">円</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { LessonRecordRepository } from "@/repository/LessonRecordRepository"
import { firestore } from "@/repository/client/firestore"
import VLessonRecord from "@/components/organisms/parent/VLessonRecord.vue"

export default {
  components: {
    VLessonRecord
  },
  data () {
    return {
      records: null,
      lessonRecordRepo: null
    }
  },
  methods: {
    async updateRecord (record, updateValue) {
      record.date = updateValue.date
      record.lesson.schedule.updateStart(updateValue.lesson.schedule.start)
      record.lesson.schedule.updateEnd(updateValue.lesson.schedule.end)
      record.lesson.wage = updateValue.lesson.wage
      record.lesson.note = updateValue.lesson.note

      const result = await this.lessonRecordRepo.update(record)
      this.records.update(result)
    },
    async removeRecord (record) {
      this.lessonRecordRepo.delete(record)
      this.records.remove(record.id)
    }
  },
  async created () {
    this.lessonRecordRepo = new LessonRecordRepository(firestore)
    this.records = await this.lessonRecordRepo.listByParentId(this.$store.getters.parent.uuid)
    this.records.sortByDate()
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>